import {makeStyles} from '@mui/styles';

const styles = makeStyles((_: Theme) => ({
    container: {
        paddingTop: 50,
        paddingBottom: 50
    },
    submitButton: {
        paddingLeft:7,
        paddingRight:7
    },
    card: {
        elevation:6,
    },
}))

export default styles